import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { ROLES, STATUSES } from "../constants/roles";

export default function RoleDashboardRedirect() {
  const { userDoc, loading } = useAuth();

  if (loading) return null; // could return a spinner
  if (!userDoc) return <Navigate to="/pending-approval" replace />;

  if (userDoc?.role === "masterAdmin" && userDoc?.status === "active") return <Navigate to="/master-admin" replace />;
  if (userDoc?.role === "teacher" && userDoc?.status === "active") return <Navigate to="/dashboard" replace />;
  if (userDoc?.role === "student" && userDoc?.status === "active") return <Navigate to="/student-dashboard" replace />;
  return <Navigate to="/pending-approval" replace />;
}